module.exports = __webpack_public_path__ + "img/TO.9fdab65c.svg";